export type SolanaCluster = 'devnet' | 'mainnet-beta'

export const SOLANA_CLUSTER: SolanaCluster =
  import.meta.env.VITE_SOLANA_CLUSTER === 'devnet' ? 'devnet' : 'mainnet-beta'
